<script>
import ProfileData from './ProfileData';
export default {
	mixins: [ProfileData],
	data() {
		return {
			JA_LOCALIZATION_IRL: this.$store.getters.isIrl
		};
	},
	computed: {
		constants() {
			return this.$store.getters.constants;
		},
		DEBT_BUDGET_MIN() {
			if (this.constants) {
				return this.constants.debtBudgetMin;
			}
			return null;
		},
		DEBT_BUDGET_MAX() {
			if (this.constants) {
				return this.constants.debtBudgetMax;
			}
			return null;
		},
		debtsSubcategories() {
			const teenLifeStageDisplayOrder = 0;
			let debtsSubcategories = [];
			if (
				this.profileData &&
				this.profileData.cmsLifeStage.displayOrder !== teenLifeStageDisplayOrder
			) {
				let debts = this.$store.getters.debts;
				debtsSubcategories = [];
				if (!this.JA_LOCALIZATION_IRL) {
					debtsSubcategories = [debts.creditCard];
				} else {
					if (debts.creditCard.amount > 0) {
						debtsSubcategories.push(debts.creditCard);
					}
				}
				if (this.profileData.studentLoanDebt > 0) {
					debtsSubcategories.push(debts.educationLoan);
				}

				debtsSubcategories.forEach(x => {
					if (!x.hasOwnProperty('budget')) {
						x.budget = 0;
					}
					x.minimum = this.calculateGuideLine(this.DEBT_BUDGET_MIN);
					x.maximum = this.calculateGuideLine(this.DEBT_BUDGET_MAX);
					if (x == debts.educationLoan) {
						x.minimum = this.profileData.minimumStudentLoanPayment;
						x.maximum = this.profileData.minimumStudentLoanPayment * 2;
					}
					if (x == debts.creditCard && debts.creditCard.amount > 0) {
						x.minimum = debts.creditCard.amount;
						x.maximum = debts.creditCard.amount * 2;
					}
				});
			}
			return debtsSubcategories;
		}
	},
	methods: {
		getTotalDebtsAmount(useLocal) {
			if (useLocal) {
				return this.debtsSubcategories.reduce((sum, item) => {
					if (item.budget > 0) {
						return sum + parseInt(item.budget);
					} else {
						return sum;
					}
				}, 0);
			}
			return this.$store.getters.debtsTotalAmount;
		}
	}
};
</script>
